import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from "../../../../Context/AuthContext";

const useVehicleStats = () => {
  const { token } = useContext(AuthContext);

  const fetchVehicleStats = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/v-stats`, {
      method: 'GET',
      headers: {
        'Content-type': 'Application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch vehicle statistics');
    }
    return response.json();
  };

  return useQuery('vehicleStats', fetchVehicleStats);
};

export default useVehicleStats;
